import { DataPrivacyScreen } from "@/app/modules/User";

export const DataPrivacy = () => {
  return <DataPrivacyScreen />;
};
